export default __webpack_public_path__ + "static/media/flame_line_top_bg_pc.ba1975cf.svg";